export { GrowingSpacer, Spacer } from "./spacing";
export { getSpacing } from "@faire/web/slate/spacing/getSpacing";

export type { SpacerMultipliersKey } from "@faire/web/slate/spacing/getSpacing";
export { SpacerMultipliers } from "@faire/web/slate/spacing/getSpacing";
